import { ImportSubFunction } from "../constants/constants-container";
import toastService from "./ToastService";
import HttpUtils from "src/utils/HttpUtils";

class Importer {
  constructor(http) {
    this.http = http;
    this.baseURL = HttpUtils.getBaseUrl();
    this.selectedBranchId = null;
  }

  setSelectedBranchId = (branchId) => {
    this.selectedBranchId = branchId;
  }

  getFileFormat = file => {
    const splittedFilenameArray = file.name.split(".");
    return splittedFilenameArray[1];
  };

  getImportUrlByFileFormat = (selectedImportSubFunction, fileFormat, importParams) => {
    switch(selectedImportSubFunction) {
      case ImportSubFunction.SMCUBE:
        if (fileFormat === "csv") {
          return (
            this.baseURL + "excel?entity=sdd" + importParams.csvItem + "&branch=" + this.selectedBranchId
          );
        } else {
          return this.baseURL + "excel?branch=" + this.selectedBranchId;
        }
      case ImportSubFunction.INDIVIDUAL_ENTITY:
        return this.baseURL + "excel/importindividualentity?branch=" + this.selectedBranchId + "&defaultMaintenanceAgencyCode=" + importParams.maintenanceAgencyId +
          "&frameworkCode=" + importParams.selectedFrameworkCode;
      default:
        throw new Error("Import type not supported")
    }
  };

  import = async (fileToImport, selectedImportSubFunction, params) => {
    if (params.specificBranch && params.specificBranch !== "") {
      this.setSelectedBranchId(params.specificBranch);
    }
    const formData = new FormData();
    formData.append("file", fileToImport);
    const fileFormat = this.getFileFormat(fileToImport);
    const importUrl = this.getImportUrlByFileFormat(selectedImportSubFunction, fileFormat, params);
    const response = await this.http.sendImportRequest(importUrl, formData);
    toastService.func_notifyIfNeededAccordingImportResponse(response);
  };
}

export default Importer;
